import React from 'react';
import { Button, Card, Spin } from 'antd';
import PropTypes from 'prop-types';
import Text from '../../shared/components/basic/Text';
import { Flex, ShowIf } from '../../shared/components';
import SelectBox from '../../shared/components/dataEntry/SelectBox';
import { isNumeric } from '../../../helpers/common.helper';

export default class FiltersContainer extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      collapse: true,
    };
  }

  onFilterSelectHandler(tipo, selection) {
    const { onFilterSelect } = this.props;
    onFilterSelect({ tipo, value: selection }, true);
  }

  onCollapseClick() {
    const { collapse } = this.state;
    this.setState({ collapse: !collapse });
  }

  drawPropiedadSelect(label, values, i) {
    const {
      filters, capitalize,
    } = this.props;
    const showValues = [
      { id: -1, nombre: 'Todos', priority: 1 },
      ...values,
    ];
    const labelIsNumeric = label != null && isNumeric(label);
    const labelId = labelIsNumeric ? label : i;
    const realLabel = (labelIsNumeric || label == null) ? { id: labelId + 10, nombre: `null_${labelId}` } : label;
    const nombreAMostrar = capitalize
      ? realLabel.nombre.charAt(0).toUpperCase() + realLabel.nombre.toLowerCase().slice(1)
      : realLabel.nombre;
    return (
      <SelectBox
        onSelect={selection => this.onFilterSelectHandler(realLabel.nombre, selection)}
        sortBy={{ priority: 'DESC', nombre: 'DESC' }}
        filterBy="nombre"
        label={{ translationId: realLabel.nombre, value: nombreAMostrar }}
        keys={{ id: 'id', descripcion: 'nombre' }}
        values={showValues}
        selection={(filters && filters[realLabel.nombre]) ? filters[realLabel.nombre] : null}
        visible={!labelIsNumeric && label != null && values && values.length > 0}
        loading={false}
      />
    );
  }

  drawPropiedades(labels, values) {
    if(!values || values.length === 0) return;
    const valuesTipos = [];
    let numPropiedadesVisibles = 0;
    for (let i = 1; i <= 8; i += 1) {
      const valuesTipo = values.filter(e => e.subtipo === i);
      if (valuesTipo && valuesTipo.length > 0) {
        valuesTipos.push(values.filter(e => e.subtipo === i));
        numPropiedadesVisibles += 1;
      }
    }
    const componentes = valuesTipos.map(values => this.drawPropiedadSelect(labels.find(e => e.subtipo === values[0].subtipo), values, values[0].subtipo));
    const numPropiedadesNoVisibles = 8 - numPropiedadesVisibles;
    for (let i = 0; i < numPropiedadesNoVisibles; i += 1) {
      componentes.push(this.drawPropiedadSelect(i, []));
    }
    const primeraLinea = [];
    const segundaLinea = [];
    for (let i = 0; i < componentes.length; i += 1) {
      if (i < 4) {
        primeraLinea.push(componentes[i]);
      } else {
        segundaLinea.push(componentes[i]);
      }
    }
    const lineasComponentes = [<Flex marginTop="16px" width="100%">{primeraLinea}</Flex>];
    if (numPropiedadesVisibles > 4) {
      lineasComponentes.unshift(<Flex width="100%">{segundaLinea}</Flex>);
    }
    return lineasComponentes;
  }

  render() {
    const style = `
      .filterCard .ant-btn.noHeightButton{
        height: inherit !important;
      }
    `;
    const {
      labels, values, loading, loaded,
    } = this.props;
    const { collapse } = this.state;
    return (
      <Card
        className="filterCard"
        bordered={false}
        m="16px 0"
        title={<Text color="#3E3E3C" fontWeight="bold" fontSize="16px" translationId="generico.filtros">Busqueda</Text>}
        extra={<Button className="noHeightButton" type="link" height="inherit" onClick={() => this.onCollapseClick()}><Text>{collapse ? 'Mostrar filtros' : 'Ocultar filtros'}</Text></Button>}
      >
        <style>{style}</style>
        <ShowIf condition={!collapse}>
          <ShowIf condition={!loading && loaded}>
            {this.drawPropiedades(labels, values)}
          </ShowIf>
          <ShowIf condition={loading || !loaded}>
            <Flex width="100%" marginTop="16px" justifyContent="center">
              <Spin />
            </Flex>
          </ShowIf>
        </ShowIf>
      </Card>
    );
  }
}
FiltersContainer.propTypes = {
  filters: PropTypes.shape({
  }).isRequired,
  capitalize: PropTypes.bool,
  loaded: PropTypes.bool,
  loading: PropTypes.bool,
  collapse: PropTypes.bool,
  values: PropTypes.arrayOf(PropTypes.shape({
  })).isRequired,
  labels: PropTypes.arrayOf(PropTypes.shape({
  })).isRequired,
  onFilterSelect: PropTypes.func.isRequired,
};
FiltersContainer.defaultProps = {
  capitalize: false,
  loaded: false,
  collapse: true,
  loading: false,
};
